import {useState} from "react";
import {App as AntdApp, Select, Alert, Empty} from "antd";
import className from "classnames/bind";
import {Button, FontAwesomeIcon, Loading} from "~/components";
import {rtkErrorMessage} from "~/reduxs/api/apiSlice";
import {
	useGetGscSitesQuery,
	useSelectGscPropertyMutation,
	useDisconnectGscMutation,
} from "~/reduxs/api/gscApiSlice";
import style from "../style/Gsc.module.scss";

const cn = className.bind(style);

/**
 * Sau khi kết nối, chọn property (site) để gắn vào dự án. Danh sách lấy từ BE
 * (sites.list qua access token). Chọn xong → BE đặt mốc backfill 16 tháng và job nền
 * bắt đầu đồng bộ.
 */
function GscPropertyPicker({projectId, email, onCancel}) {

	const {notification} = AntdApp.useApp();
	const {data: sites = [], isLoading, isError, error} = useGetGscSitesQuery(projectId);
	const [selectProperty, {isLoading: saving}] = useSelectGscPropertyMutation();
	const [disconnect] = useDisconnectGscMutation();
	const [property, setProperty] = useState(null);

	const handleSave = async () => {
		if (!property) {
			notification.warning({message: 'Chưa chọn', description: 'Vui lòng chọn một property.'});
			return;
		}
		try {
			await selectProperty({projectId, property_url: property}).unwrap();
			notification.success({message: 'Đã chọn property', description: 'Hệ thống đang đồng bộ dữ liệu trong nền.'});
		} catch (e) {
			notification.error({message: 'Lỗi', description: rtkErrorMessage(e, 'Không lưu được property')});
		}
	};

	const handleDisconnect = async () => {
		try {
			await disconnect(projectId).unwrap();
		} catch (e) {
			notification.error({message: 'Lỗi', description: rtkErrorMessage(e, 'Không ngắt được kết nối')});
		}
	};

	if (isLoading) return <Loading />;

	return (
		<div className={cn('connectPanel')}>
			<div className={cn('connectIcon')}>
				<FontAwesomeIcon icon="fa-light fa-list-check" />
			</div>
			<div className={cn('connectTitle')}>Chọn property</div>
			<div className={cn('connectDesc')}>
				{email ? <>Đã kết nối bằng <strong>{email}</strong>. </> : null}
				Chọn website (property) trong Search Console để đồng bộ dữ liệu cho dự án này.
			</div>

			{isError && (
				<Alert type="error" showIcon style={{textAlign: 'left', marginBottom: 16}}
					message="Không lấy được danh sách property"
					description={rtkErrorMessage(error, 'Vui lòng thử ngắt kết nối và kết nối lại.')} />
			)}

			{!isError && sites.length === 0 && (
				<Empty description="Tài khoản Google này chưa có property nào trong Search Console." style={{marginBottom: 16}} />
			)}

			{sites.length > 0 && (
				<Select
					style={{width: '100%', maxWidth: 460, marginBottom: 20, textAlign: 'left'}}
					placeholder="Chọn property…"
					value={property}
					onChange={setProperty}
					options={sites.map((s) => ({
						value: s.siteUrl,
						label: `${s.siteUrl}  (${s.permissionLevel})`,
					}))}
				/>
			)}

			<div style={{display: 'flex', gap: 10, justifyContent: 'center'}}>
				{onCancel
					? <Button white onClick={onCancel}>Huỷ</Button>
					: <Button white onClick={handleDisconnect}>Ngắt kết nối</Button>}
				{sites.length > 0 && (
					<Button primary loading={saving} onClick={handleSave}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-check" />}>
						Bắt đầu đồng bộ
					</Button>
				)}
			</div>
		</div>
	);
}

export default GscPropertyPicker;
